import React from 'react';
import { LoginWidget } from '../../auth/okta-widget-customizations/LoginWidget';
import { LoginLayoutX4EC } from './LoginLayoutX4EC';

export const LoginViewX4EC = () => {
  return (
    <LoginLayoutX4EC>
      <LoginWidget primaryAuthTitle="Sign in to manage your subscription." />
    </LoginLayoutX4EC>
  );
};
